module.exports = __webpack_public_path__ + "img/card.3d5ef4a9.svg";